import { createSelector } from '@reduxjs/toolkit';
import { EditIcon } from 'evergreen-ui';
import { dcpcApi } from './dcpcApi';

const VOC_STATUSES_TAG = 'VocStatuses';

dcpcApi.enhanceEndpoints({ addTagTypes: [VOC_STATUSES_TAG] });
const vocStatusesApi = dcpcApi.injectEndpoints({
  endpoints: (builder) => ({

    getVocStatuses: builder.query({
      query: () => 'vocstatuses',
      providesTags: [VOC_STATUSES_TAG],
    }),

    getVocStatus: builder.query({
      query: (id) => `vocstatus/${id}`,
      providesTags: [VOC_STATUSES_TAG],
    }),

    updateVocStatus: builder.mutation({
      query: ({ id, body }) => ({
        url: `vocstatus/${id || ''}`,
        method: id ? 'PUT' : 'POST',
        body,
      }),
      invalidatesTags: [VOC_STATUSES_TAG],
    }),

    getVocStatusesDatasourceMessage: builder.query({
      query: () => 'vocstatuses/datasource_message',
    }),

    getVocStatusesByFilter: builder.query({
      query: (params) => ({
        url: 'vocstatuses',
        method: 'GET',
        params,
      }),
    }),
  }),
});

export const {
  useGetVocStatusesQuery,
  useGetVocStatusQuery,
  useUpdateVocStatusMutation,
  useGetVocStatusesDatasourceMessageQuery,
  useGetVocStatusesByFilterQuery,
} = vocStatusesApi;

export const vocStatusesSelect = (state) => vocStatusesApi.endpoints.getVocStatuses.select()(state);
export const vocStatusesSelector = (state) => vocStatusesSelect(state).data || [];

const filterVocStatusesBySearchTextSelector = createSelector(
  vocStatusesSelector,
  (_, searchText) => searchText,
  (vocStatuses, searchText) => ({
    columns: [
      {
        label: 'Статус',
      },
      {
        label: 'Тип сообщения',
      },
      {
        label: 'Описание типа',
      },
    ],
    rows: vocStatuses.reduce((acc, cur) => {
      const {
        id, status, entityType, statusType,
      } = cur;
      const row = [id, status, entityType, statusType];
      if (row.filter((elem, idx) => elem === 'ERROR' && idx !== 0 && elem !== null && elem.toUpperCase().includes(searchText.toUpperCase())).length > 0) {
        acc.push(row);
      }
      return acc;
    }, []),
    rowButtons: [
      {
        label: 'Редактировать',
        to: (id) => `${id}`,
        icon: EditIcon,
      },
    ],
    createLink: {
      label: 'Создать статус',
    },
  }),
);

export const vocStatusesBySearchTextSelector = (searchText) => (state) => filterVocStatusesBySearchTextSelector(state, searchText);
